import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/main.css"
import "./Styles/res.css"
import "./Styles/tab.css"
import "./Styles/accordion.css"
import "./Styles/ageRange.css"
import "./Styles/heightRange.css"
import "./Styles/my_photos.css"
import "./Styles/nav.css"
import "./Styles/chat.css";
import "./Styles/liveChat.css";
import "./Styles/owl.css";
import "./Styles/owl.carousel.min.css";
import "./Styles/acttionBtns.css";
import { analytics } from './services/firebaseConfig';

import { ThemeProvider } from "@mui/material/styles";
import muiTheme from "./theme/muiTheme";

// import { Provider } from 'react-redux';
// import store from './store';

import { HelmetProvider } from "react-helmet-async";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
<HelmetProvider>
  <ThemeProvider theme={muiTheme}>
      <App />
      </ThemeProvider>
    </HelmetProvider> 
    
     </React.StrictMode>
);
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('/sw.js').then(registration => {
//       console.log('SW registered: ', registration);
//     }).catch(registrationError => {
//       console.log('SW registration failed: ', registrationError);
//     });
//   });
// }
console.log("firebase Analytics", analytics);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
